// export const serverUri = 'http://localhost:8080'
export const serverUri = 'https://gsgn.linkingtrip.cn'

export const apiUrl = 'https://api.h5.linkingtrip.cn'

export const markerData = [
    {
        "id": 1,
        "type": 1,
        "name": "寿带观鸟点",
        "address": "屯溪区傍霞村",
        "desc": "在傍霞村已观测记录到45种珍稀鸟类，其中有国家二级重点保护动物6种，傍霞观鸟目标主要以寿带为主，其他林鸟为辅。据研究数据记载，如蓝喉蜂虎、画眉、赤腹鹰、黑冠鹃隼等，其中包含明星鸟种“林中仙子”寿带。在这里，不仅能登高鬲山、生态观鸟，也可泛舟月亮湾、露营率水河畔，既有“烟火气”又见“生态绿”。",
        "icon": "marker/1/marker.png",
        "icon_scale": 90,
        "wh": 0.987,
        "thumbs": [],
        "longitude": "118.261298",
        "latitude": "29.67401",
        "icon_longitude": "118.371298",
        "icon_latitude": "29.62401",
        "scale": 100
    },
    {
        "id": 2,
        "type": 1,
        "name": "普通鳾观鸟点",
        "address": "徽州区西溪南",
        "desc": "普通鳾观鸟点主要集中在西溪南地区，西溪南目前记录到鸟类16个目46科117种，其中包括国家一级保护鸟类黄胸鹀、国家二级保护鸟类白鹇、黑冠鹃隼、赤腹鹰、雀鹰、红隼、斑头鸺鹠、画眉、红嘴相思鸟。西溪南可选择全年的早上5-9时进行观鸟活动，或者在丰乐河中秋冬季全时段进行水鸟观察拍摄活动。村内风光绮丽、白墙黑瓦、溪泉环绕，千亩枫杨林掩映其中，宛如现实版“绿野仙踪”。如今这个千年的历史古村以创意赋能，民宿、咖啡、市集、艺术馆、水上竹筏、小火车、热气球、向云端西西里秘境等创意产业集聚，已成为游客来徽州必打卡网红新地标。",
        "icon": "marker/2/marker.png",
        "icon_scale": 68,
        "wh": 1.389,
        "thumbs": [],
        "longitude": "118.292504",
        "latitude": "29.832026",
        "icon_longitude": "118.292504",
        "icon_latitude": "29.832026",
        "scale": 100
    },
    {
        "id": 3,
        "type": 1,
        "name": "白鹇观鸟点",
        "address": "祁门县石迹村",
        "desc": "在石迹村已观测到40余种鸟类，其中包括白鹇、白颈长尾雉、红嘴蓝鹊等，以白鹇为主，总体数量有百余只。\n白鹇为晨昏活动，因此可选择全年的早上7-9时以及下午4-6时进行观鸟和拍摄。",
        "icon": "marker/3/marker.png",
        "icon_scale": 70,
        "wh": 1.389,
        "thumbs": [],
        "longitude": "117.532098",
        "latitude": "29.866307",
        "icon_longitude": "117.532098",
        "icon_latitude": "29.866307",
        "scale": 100
    },
    {
        "id": 4,
        "type": 1,
        "name": "雁鸭类、鸻鹬类 观鸟点",
        "address": "黄山区乌石镇",
        "desc": "黄山区乌石镇位于太平湖西南侧，每年在秋冬季节，大量的越冬候鸟，如东方白鹳、白额雁、豆雁、金眶鸻等在此进行停歇和越冬，可在秋冬季节全天进行拍摄。周边有太平湖景区、太平湖湿地公园等地可供游玩，也有皖美金宿——梅姑娘的院子可供住宿。",
        "icon": "marker/4/marker.png",
        "icon_scale": 65,
        "wh": 1.983,
        "thumbs": [],
        "longitude": "117.972265",
        "latitude": "30.250161",
        "icon_longitude": 118.139766,
        "icon_latitude": 30.151227,
        "scale": 100
    },
    {
        "id": 5,
        "type": 1,
        "name": "雁鸭类观鸟点",
        "address": "歙县王村",
        "desc": "王村镇拥有丰富的越冬水鸟资源，据不完全统计，在秋冬季节，至少30种以上的越冬水鸟在此栖息或越冬，如中华秋沙鸭、鸳鸯、绿翅鸭等。明星鸟种为中华秋沙鸭、鸳鸯，重点鸟种有绿翅鸭等。可在秋冬季节全天进行拍摄。周边景区点有：杏村草原、雄村景区等。",
        "icon": "marker/5/marker.png",
        "icon_scale": 67,
        "wh": 1.389,
        "thumbs": [],
        "longitude": "118.40689",
        "latitude": "29.759357",
        "icon_longitude": "118.63089",
        "icon_latitude": "29.759357",
        "scale": 100
    },
    {
        "id": 6,
        "type": 2,
        "name": "休宁县鹤城新安源古树群",
        "address": "休宁县鹤城乡新安源村",
        "desc": "黄山市面积最大、树种最多、树龄最长的生态原始水口林，国家一级保护植物南方红豆杉在这里有惊人的56株，拥有千年枫、枫杨、望春花、红豆杉等30多种树种。树林高度近30米，胸围3米以上的古树有十多株，百年树龄以上的古树近两百株，其中香榧、糙叶树、枫香多棵达1000多年树龄，周边有徽饶古道和方氏宗祠，还有右龙板凳龙非遗表演。",
        "icon": "marker/6/marker.png",
        "icon_scale": 83,
        "wh": 1.748,
        "thumbs": [
            "marker/6/6-休宁县鹤城新安源古树群 .png"
        ],
        "longitude": "117.73",
        "latitude": "29.605277",
        "icon_longitude": "117.73",
        "icon_latitude": "29.605277",
        "scale": 100
    },
    {
        "id": 7,
        "type": 2,
        "name": "黟县宏村镇塔川闭上古树群",
        "address": "塔川村景区",
        "desc": "位于塔川景区，距县城12公里，拥有多棵树龄超千年的国家一级保护古树，占地0.3公顷，总株数66株，主要树种为小叶栎与青冈栎，其中乌桕、枫香等树种尤为著名，秋季红叶景观被《中国国家地理》评为“中国三大秋色之一”。古树群核心保护区内，挂牌保护的百年以上古树达30余棵，部分入选“安徽省名木古树保护名录”。\n传说南宋时期，村民为避战乱迁居于此，依古树建村，认为树灵庇佑一方水土。其中一棵“姻缘树”被当地视为爱情象征，相传恋人绕树三圈可白头偕老。清代诗人曾以“古木荫中系短篷”描绘其意境。\n周边旅游资源丰富：北接世界文化遗产宏村（车程5分钟），东邻木坑竹海，西通奇墅湖。村内民宿集群如“塔川书院”“御前侍卫”将徽派建筑与现代美学融合，秋日推窗即见红叶漫山。美食推荐“宏村宴”三绝——臭鳜鱼、石耳炖鸡、腊八豆腐，古树群入口处还有农家现做的蟹壳黄烧饼。最佳游览期为11月中下旬，红叶节期间还有民俗晒秋活动。",
        "icon": "marker/7/marker.png",
        "icon_scale": 78,
        "wh": 1.748,
        "thumbs": [
            "marker/7/微信图片_2025-07-22_161718_294.jpg"
        ],
        "longitude": "118.0019444",
        "latitude": "30.0152777777778",
        "icon_longitude": "117.7019444",
        "icon_latitude": "30.0152777777778",
        "scale": 100
    },
    {
        "id": 8,
        "type": 2,
        "name": "黟县宏村镇塔川景区古树群",
        "address": "塔川村景区",
        "desc": "位于塔川景区，距县城12公里。核心区拥有数十棵国家一级保护古树，包括树龄超500年的香樟、枫香、乌桕等，其中多株入选安徽省古树名木保护名录。占地12公顷，总株数196株，主要树种为乌桕。黟县宏村镇塔川古树群是皖南最具代表性的古木群落之一，古树群所在的塔川村，因秋色绝美被《中国国家地理》评为“中国三大秋色胜地”之一，并列入中国传统村落保护名录，成为摄影爱好者和写生者的天堂。\n\n故事性方面，当地流传着“树神护村”的传说：明末战乱时，村民藏于古树林中避祸，后认为古树有灵，世代祭拜。其中一棵“五谷树”尤为神奇，据说其果实形状能预示当年收成。此外，塔川的乌桕红叶被文人誉为“霜叶红于二月花”，清代徽商返乡时常在此植树立碑，祈求家族兴旺。\n\n周边配套丰富：\n景区联动：紧邻宏村（车程5分钟）、木坑竹海（《卧虎藏龙》取景地）、卢村木雕楼，可串联游览。\n特色民宿：推荐“塔川秋韵”“晴园民宿”，部分房间直面古树群，推窗即见红叶云海。\n在地美食：必尝“徽州三宝”（毛豆腐、臭鳜鱼、火腿炖笋），村口老茶馆还供应现炒的黄山野茶，搭配酥脆的梅干菜烧饼，风味独特。\n每年11月红叶节期间，古树群周边会举办晒秋、舞草龙等民俗活动，烟火气十足。",
        "icon": "marker/8/marker.png",
        "icon_scale": 83,
        "wh": 1.748,
        "thumbs": [
            "marker/8/8-黟县宏村镇塔川景区古树群.jpg"
        ],
        "longitude": "117.9997222",
        "latitude": "30.0138888888889",
        "icon_longitude": "117.7997222",
        "icon_latitude": "29.9138888888889",
        "scale": 100
    },
    {
        "id": 9,
        "type": 2,
        "name": "黟县碧阳南屏万松林古树群",
        "address": "碧阳镇南屏村",
        "desc": "位于南屏景区，距县城4.2公里，部分树木达到国家二级保护标准，是皖南地区罕见的古松树群落，其中多棵古松树龄超300年，占地0.2公顷，总株数37株，主要树种为枫香、樟树，被列入安徽省古树名木保护名录。南屏村本身是中国历史文化名村，并入选中国传统村落名录，万松林作为其核心生态景观，具有重要的生态和文化遗产价值。\n相传清代时，南屏村一位富商为祈福家族昌盛，在此种植松树百棵，形成“松涛听雨”的胜景。当地还流传“松仙护村”的传说：太平天国时期，村民在松林躲避战乱，夜间松林间似有神兵列阵，吓退追兵，故村民世代视古松为守护神。此外，南屏村作为《菊豆》《卧虎藏龙》等电影的取景地，万松林也曾入镜，增添几分影视文化色彩。景区联动：紧邻南屏古村（迷宫般的徽州祠堂群）、关麓“八大家”联体古民居（车程10分钟），与宏村、西递形成黄金旅游三角。清晨或傍晚漫步松林，感受“万松森森，风过如涛”的意境，深秋时节松针铺地，更显幽静古朴。\n",
        "icon": "marker/9/marker.png",
        "icon_scale": 83,
        "wh": 1.748,
        "thumbs": [
            "marker/9/9-黟县碧阳南屏万松林古树群.jpg"
        ],
        "longitude": "117.902361",
        "latitude": "29.902426",
        "icon_longitude": "117.902361",
        "icon_latitude": "29.702426",
        "scale": 100
    },
    {
        "id": 10,
        "type": 2,
        "name": "祁门县芦溪楠木古树群",
        "address": "祁门县芦溪乡芦溪村碧桃组",
        "desc": "碧桃楠木林位于芦溪乡芦溪村碧桃组，现有国家二级保护植物浙江楠239株，平均树高20余米，树龄多达200余年，为碧桃组的水口林。是华东地区目前发现的最大野生楠木群落。占地面积10余亩，古树群楠木珍稀、高大挺直、蔚然成景，宛如一颗镶嵌在阊江绿带上的“绿色宝石” 。\n据康氏族谱记载，明嘉靖年间，康氏“载公”在云南为官,卸老还乡时便带回种子在水口林中种植.并在离世之前弥留之际，告诫子孙，日后若是康氏子孙外出为官或远嫁官宦人家为妻的，可在水口林中取一截木材，打造两把椅子或一个箱子等简便轻巧的家具或嫁妆带走，以蒙祖先庇佑及告诫不忘根本。",
        "icon": "marker/10/marker.png",
        "icon_scale": 80,
        "wh": 1.509,
        "thumbs": [
            "marker/10/10-祁门县芦溪楠木古树群.jpg"
        ],
        "longitude": "117.4872222",
        "latitude": "29.6980555555556",
        "icon_longitude": "117.4872222",
        "icon_latitude": "29.6980555555556",
        "scale": 100
    },
    {
        "id": 11,
        "type": 2,
        "name": "祁门县平里梅南公园古树群",
        "address": "平里镇平里村",
        "desc": "梅南公园面积26亩，现有三级古树152株，主要树种有南紫薇、构树、望春花、朴树、国槐、枫杨、麻栎、小叶栎、三角枫、黄连木等。\n这片古树林原来是村庄的水口林，旁边就是梅南渡古渡码头。唐宋时期，祁门茶市热闹非凡，所产茶叶品质优良，通过阊江水运将茶叶运输到江西。梅南渡作为重要渡口，承担着歙州茶以及后来祁门红茶等货物的外运使命，这里也是万里茶道祁门红茶外销的起运点。公园旁有小型停车场，不远处的一然书院餐厅和梅南渡时光咖啡屋，可供游客休闲用餐。公园对面的祁民公社是数字游民的集聚点，其中有20余间客房对游客开放。",
        "icon": "marker/11/marker.png",
        "icon_scale": 83,
        "wh": 1.748,
        "thumbs": [
            "marker/11/11-祁门县平里梅南公园古树群.jpg"
        ],
        "longitude": "117.60918",
        "latitude": "29.7324198",
        "icon_longitude": "117.60918",
        "icon_latitude": "29.7324198",
        "scale": 100
    },
    {
        "id": 12,
        "type": 2,
        "name": "祁门县渚口乡滩下古树群",
        "address": "祁门县渚口乡大北村滩下组",
        "desc": "位于祁门县渚口乡大北村滩下组，林中树龄超百年的古树达30余株，其中多株枫杨、香樟被列为国家二级古树，枝繁叶茂的古银杏更是省级保护古树，堪称“天然活化石群落”。\n古树林周边紧邻渚口古村落景区，漫步可赏明清徽派建筑：贞一堂、一府六县；美食推荐“板栗烧鸡”、灯笼辣椒，鲜醇滋味融入山林气息，让人流连忘返。",
        "icon": "marker/12/marker.png",
        "icon_scale": 83,
        "wh": 1.748,
        "thumbs": [
            "marker/12/12-祁门县渚口乡滩下古树群.jpg"
        ],
        "longitude": "117.494708",
        "latitude": "29.846229",
        "icon_longitude": "117.494708",
        "icon_latitude": "29.846229",
        "scale": 100
    },
    {
        "id": 13,
        "type": 2,
        "name": "黄山区新明乡樵山古榧树群",
        "address": "新明乡樵山村",
        "desc": "位于新明乡樵山村，拥有百年古榧树两百余株，其中千年古榧2株，500年以上古榧6株，由5处集中连片的区域构成，占地面积约110余亩。最大一株胸围达7.1米，相传古树被神仙拂过，被当地百姓称为“神仙榧、香榧王”。这里也是《黄山报》旧址所在地，1947年秋，中共皖南地委在这里创刊发行了苏浙皖根据地唯一一份党报——《黄山报》，革命的曙光曾在这里升起，您可以在《黄山报》旧址浏览图文并茂的展板，观赏珍稀的历史文物。",
        "icon": "marker/13/marker.png",
        "icon_scale": 83,
        "wh": 1.748,
        "thumbs": [
            "marker/13/13-黄山区新明乡樵山古榧树群.jpg"
        ],
        "longitude": "118.227268",
        "latitude": "30.394392",
        "icon_longitude": "117.927268",
        "icon_latitude": "30.394392",
        "scale": 100
    },
    {
        "id": 14,
        "type": 2,
        "name": "徽州区潜口镇唐模古银杏树",
        "address": "唐模村",
        "desc": "为唐模先祖汪思立建村选址所植，距今1390余年，被誉为“徽州第一长者”,至今仍傲然挺立。唐模人绕古银杏而居千年，打造出了处处体现人与自然和谐的唐模村，现在的唐模享有“风雅山水田园，徽派古建长廊”和“中国水口园林第一村”的美誉。近年来，唐模景区结合自身特色，不断推陈出新，推出碑拓研学课程、悠悠云露营基地、唐模八大碗美食体验、法国家庭旅馆等多种业态，吸引大量市民游客前来游玩体验。",
        "icon": "marker/14/marker.png",
        "icon_scale": 85,
        "wh": 1.956,
        "thumbs": [
            "marker/14/14-徽州区潜口镇唐模古银杏树.jpg"
        ],
        "longitude": "118.3294444",
        "latitude": "29.87",
        "icon_longitude": "118.3294444",
        "icon_latitude": "29.87",
        "scale": 100
    },
    {
        "id": 15,
        "type": 2,
        "name": "歙县深渡镇漳潭古樟",
        "address": "歙县深渡镇",
        "desc": "名木，在2023年全国“双百”古树推选活动中，千年古樟入选全国10大最美古樟之一。有着“天下第一樟”的美誉，树龄逾千年，传说为此树是为汉高祖刘邦的功臣张良的后裔亲手栽下。树高达30米，周长为11.7米，主干围径均在1.5米以上，需要7到9人才能合抱。樟树周边还有红妆馆、九姓捕鱼表演等景点。",
        "icon": "marker/15/marker.png",
        "icon_scale": 85,
        "wh": 1.956,
        "thumbs": [
            "marker/15/15-歙县深渡镇漳潭古樟.JPG"
        ],
        "longitude": "118.5576389",
        "latitude": "29.8221389",
        "icon_longitude": "118.5576389",
        "icon_latitude": "29.8221389",
        "scale": 100
    },
    {
        "id": 16,
        "type": 2,
        "name": "歙县雄村镇荃村千年古樟",
        "address": "雄村镇荃村",
        "desc": "一级古树，树龄1000余年（传说古树始植于宋初）。古树一株两枝，从1米处分生两枝，1米处树围1010厘米，主枝胸围520厘米，次枝胸围480厘米，树高23米，冠幅达21米*26米。此古樟树下立有一块护树禁碑，于清光绪二十一年（公元1895年）由江南徽州府歙县五品正堂所立。据考证此碑是安徽省现存唯一保存完整为保护古树而立的古代禁碑，体现了古人对古树名木保护的重视。古树周边景区有雄村、棠樾牌坊群鲍家花园、黄山市中国供销主题园、徽州古城等。",
        "icon": "marker/16/marker.png",
        "icon_scale": 86,
        "wh": 1.956,
        "thumbs": [
            "marker/16/16-歙县雄村镇荃村千年古樟.jpg"
        ],
        "longitude": "118.4441667",
        "latitude": "29.8205556",
        "icon_longitude": "118.4441667",
        "icon_latitude": "29.8205556",
        "scale": 100
    },
    {
        "id": 17,
        "type": 2,
        "name": "歙县雄村镇朱村茂荫古樟树",
        "address": "歙县雄村镇义成村口",
        "desc": "一级古树，树龄600年，树高14米，树围850厘米，冠幅19米。位于歙县雄村镇义成村口，斑驳的树身布满青苔，需五六人牵手合围，树干4米以下形成了独特的树洞，洞里可同时站立四五个成年人。当地人称为“茂荫古樟”。据说，马克思《资本论》中唯一提到的中国人—王茂荫（清代，1798年-1865年），晚年定居义成后，每逢客人到访，迎来送往，必在此樟树下。古树周边景区有：雄村、棠樾牌坊群鲍家花园、黄山市中国供销主题园、徽州古城等。",
        "icon": "marker/17/marker.png",
        "icon_scale": 86,
        "wh": 1.956,
        "thumbs": [
            "marker/17/17-歙县雄村镇朱村茂荫古樟树.jpg"
        ],
        "longitude": "118.4430556",
        "latitude": "29.7763889",
        "icon_longitude": "118.4430556",
        "icon_latitude": "29.7763889",
        "scale": 100
    },
    {
        "id": 18,
        "type": 2,
        "name": "歙县昌溪乡昌溪村龙凤樟古树公园",
        "address": "昌溪乡昌溪村",
        "desc": "有两株树龄均为800年，均属一级古树，树径3-4米的古树组成，高23米，冠幅如巨伞，因形似龙腾凤舞得名“龙凤樟”，被村民视为村落守护神。树冠投影达2600平方米的庞大体量，实为江南现存最完整的古樟连理景观。明清时期，昌溪商人临行必绕树三匝，取其\"根基稳固、枝脉相通\"之意。1958年，为熬樟脑油，有人想砍掉这两株古树，乡民以身体筑起屏障，自发守护古樟，折射出徽州\"千金义聚\"的社群精神。古树周边景区点有：昌溪古村落、阳产土楼、新安江山水画廊等。",
        "icon": "marker/18/marker.png",
        "icon_scale": 86,
        "wh": 1.992,
        "thumbs": [
            "marker/18/18-歙县昌溪乡昌溪村龙凤樟古树公园.jpg"
        ],
        "longitude": "118.6444444",
        "latitude": "29.9133333333333",
        "icon_longitude": "118.6444444",
        "icon_latitude": "29.9133333333333",
        "scale": 100
    },
    {
        "id": 19,
        "type": 2,
        "name": "歙县徽城镇南源口村王村茂古樟树",
        "address": "徽城镇南源口村王村茂自然村水口庙",
        "desc": "共有3株古樟树，名木2株，二级古树1株，其中：古树编号为34102100102，树龄500年，名木，胸围700厘米，古树下边上有一古井，用于灌溉周边农田；古树编号为34102100103，树龄500年，名木，胸围1164厘米，这株树形状像人伸展的五指，当地村民都习惯称它为“五指樟”；古树编号34102120015，二级古树，胸围618厘米，2013年因雪压折断过，现有一支撑。当年为了保护此处的古樟树，徽杭高速公路和G56高速公路，在建设中进行绕道避让，由此在当地传为佳话。古树周边景区点有徽州古城、新安江山水画廊等。",
        "icon": "marker/19/marker.png",
        "icon_scale": 86,
        "wh": 2.031,
        "thumbs": [
            "marker/19/19-歙县徽城镇南源口村王村茂古樟树.jpg"
        ],
        "longitude": "118.5029444",
        "latitude": "29.8608611",
        "icon_longitude": "118.5029444",
        "icon_latitude": "29.8608611",
        "scale": 100
    },
    {
        "id": 20,
        "type": 2,
        "name": "黟县宏村镇宏村牛角红杨古树",
        "address": "黟县宏村村口",
        "desc": "名木，枫杨，树龄500年，此树高虬曲纵横，树干绿苔密附，华冠浓荫蔽日，硕果串串摇曳，风景十分动人。相传清康熙年间，宏村一位方姓青年考中了秀才，欣喜不已，举村庆贺。村民择吉日栽下这株枫杨，世世代代善加保护，以树为鉴，激励后人。",
        "icon": "marker/20/marker.png",
        "icon_scale": 86,
        "wh": 1.956,
        "thumbs": [
            "marker/20/20-黟县宏村镇宏村牛角红杨古树.jpg"
        ],
        "longitude": "117.9811111",
        "latitude": "30.005",
        "icon_longitude": "117.9811111",
        "icon_latitude": "29.805",
        "scale": 100
    },
    {
        "id": 21,
        "type": 2,
        "name": "屯溪区程氏三宅罗汉松",
        "address": "屯溪区柏树街程氏三宅28号宅后院",
        "desc": "三级古树，树高8米，树围50厘米，冠幅6*8米，树龄285年，这株罗汉松在程氏三宅后院中挺拔了280多年，如今老树发新枝，越发的茂盛，枝干苍劲有力，叶片翠绿欲滴。程氏三宅作为第五批全国重点文物保护单位，结构严谨，装饰精美，古朴素雅。罗汉松默默注视着200多年的风云变幻，是程氏三宅中一道亮丽的风景线。美食推荐：步行大润发商业街夜市，集合各地小吃，如徽州臭豆腐、黄豆肉馃，边走边吃，纵享美味。",
        "icon": "marker/21/marker.png",
        "icon_scale": 86,
        "wh": 1.956,
        "thumbs": [
            "marker/21/21-屯溪区程氏三宅罗汉松.jpg"
        ],
        "longitude": "118.3142302",
        "latitude": "29.711838",
        "icon_longitude": "118.3142302",
        "icon_latitude": "29.711838",
        "scale": 100
    },
    {
        "id": 22,
        "type": 2,
        "name": "迎客松",
        "address": "黄山风景区海拔1680m的玉屏峰狮石旁",
        "desc": "名木，1990列入世界文化与自然遗产名录。树高10.15m、胸围2.05m、冠幅10.7m*13.7m，下部两大侧枝长7.6m，树龄逾1000年，。迎客松之名始见于清咸丰九年(公元1859年)歙县人黄肇敏《游黄山记》，目前能看到的迎客松最早照片是汪采白1912年拍摄的，1929年，太平县人陈少峰在其所著《黄山指南》中选取迎客松照片刊于全书正文之前，迎客松才广为世人所知。",
        "icon": "marker/22/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/22/22-迎客松.jpg"
        ],
        "longitude": "118.17044",
        "latitude": "30.12450277",
        "icon_longitude": "118.13044",
        "icon_latitude": "30.15150277",
        "scale": 100
    },
    {
        "id": 23,
        "type": 2,
        "name": "黑虎松",
        "address": "海拔1620m的往白鹅岭、始信峰和北海三条游步道的交汇处",
        "desc": "一级古树，1990列入世界文化与自然遗产名录。树高7.5m、胸围2.25m、冠幅14m*12.7m，名木，黑虎松枝稠叶密，遮天闭日，覆盖面积约百余平方米。传说很早以前有一位僧人去狮子林，途中忽见一只黑虎卧在松树顶上，他仔细看时，却又找不到黑虎。走下山坡仰头望去，只见整个树形如狂草书写的“虎”字，于是“黑虎松”的名字就这样流传下来。",
        "icon": "marker/23/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/23/23-黑虎松.jpg"
        ],
        "longitude": "118.1680556",
        "latitude": "30.1425",
        "icon_longitude": "118.2680556",
        "icon_latitude": "30.3025",
        "scale": 100
    },
    {
        "id": 24,
        "type": 2,
        "name": "接引松",
        "address": "海拔1664m始信峰",
        "desc": "名木，1990列入世界文化与自然遗产名录。树高3.9m、胸围1.05m、冠幅5.3m*3.8m，明代黄习远在僧一乘陪同下游览始信峰，“援其枝悬渡”。清人刘大櫆亦有记载：“北岸有松，横枝直抵南岸”。后改木桥为石桥，名“渡仙桥”。",
        "icon": "marker/24/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/24/24-接引松.jpg"
        ],
        "longitude": "118.1697222",
        "latitude": "30.1436111",
        "icon_longitude": "118.1697222",
        "icon_latitude": "30.2946111",
        "scale": 100
    },
    {
        "id": 25,
        "type": 2,
        "name": "笔花松(梦笔生花)",
        "address": "黄山北海海拔1594米的散花坞笔峰之巅",
        "desc": "名木，树高1.75m，基径0.12m，冠幅2.34m*2.28m，树龄约50年。峰顶原有扰龙松，旧志列为九大名松之首，人称“帝松”。",
        "icon": "marker/25/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/25/25-笔花松(梦笔生花).jpg"
        ],
        "longitude": "118.1675",
        "latitude": "30.1436111",
        "icon_longitude": "118.1675",
        "icon_latitude": "30.3466111",
        "scale": 100
    },
    {
        "id": 26,
        "type": 2,
        "name": "蒲团松",
        "address": "黄山海拔1611米的玉屏峰索道上站房附近",
        "desc": "名木，被列入世界文化与遗产名录。主干较矮，顶部侧枝密集盘曲，针叶簇集冠顶，铺展平整，状似蒲团。树高2.15米，胸围1.5米，枝下高1.65米，冠幅10.5米*9.7米。清人丁延楗《蒲团松》诗：“苍松三尺曲如盘，铁干横披半亩宽，疑是浮丘趺坐处，至今留得一蒲团。”",
        "icon": "marker/26/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/26/26-蒲团松.jpg"
        ],
        "longitude": "118.1683333",
        "latitude": "30.1358333",
        "icon_longitude": "118.0683333",
        "icon_latitude": "30.1358333",
        "scale": 100
    },
    {
        "id": 27,
        "type": 2,
        "name": "探海松",
        "address": "黄山海拔1670米的始信峰危崖上",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录。有一侧枝很长，伸入云海，犹如苍龙探取海中之物，故名。树高3.1米，胸围1.13米，枝下高1.05米，冠幅6.5*6.6米，树龄逾500年。",
        "icon": "marker/27/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/27/27-探海松.JPG"
        ],
        "longitude": "118.17",
        "latitude": "30.1436111",
        "icon_longitude": "118.303",
        "icon_latitude": "30.1429111",
        "scale": 100
    },
    {
        "id": 28,
        "type": 2,
        "name": "黄山木莲",
        "address": "海拔714米的温泉听涛居（干部疗养院门前）",
        "desc": "名木，为木兰科木莲属常绿乔木，叶革质，喜温暖湿润气候及肥沃的酸性土壤。5月中下旬开花，单生枝顶，形似莲花，故名“木莲”。果实可供药用，有助于健身延年。黄山古木莲很多，其中干部疗养院门前一株，高17米，胸围2.36米，冠幅11.8米*11米。",
        "icon": "marker/28/marker.png",
        "icon_scale": 80,
        "wh": 1.242,
        "thumbs": [
            "marker/28/黄山木莲.jpg",
            "marker/28/黄山木莲02.jpg"
        ],
        "longitude": "118.1666667",
        "latitude": "30.1030556",
        "icon_longitude": "118.1666667",
        "icon_latitude": "30.0630556",
        "scale": 100
    },
    {
        "id": 33,
        "type": 2,
        "name": "倒挂松",
        "address": "海拔1839米的黄山莲花新道循环洞下、左侧峰壁上",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录。松根盘生于石缝，主干粗短，侧枝多长，逆悬危崖，似虬龙倒挂。树高3.1米，胸围1.70米，冠幅7米*7.5米。",
        "icon": "marker/33/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/33/倒挂松.jpg"
        ],
        "longitude": "118.1661111",
        "latitude": "30.1272222",
        "icon_longitude": "117.9061111",
        "icon_latitude": "30.1272222",
        "scale": 100
    },
    {
        "id": 34,
        "type": 2,
        "name": "华东黄杉",
        "address": "海拔884米以上的黄山云谷寺北",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录。树高20.5米，胸围2.9米，冠幅21米*19.5米，古树最初命名为“黄杉”，后正式定名为华东黄杉。是我国特有的第三纪孑遗植物，被国家列为重点保护树种。",
        "icon": "marker/34/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            'marker/34/wechat_2025-07-17_114703_261.jpg',
            'marker/34/wechat_2025-07-17_145516_419.jpg'
        ],
        "longitude": "118.1861111",
        "latitude": "30.1194444",
        "icon_longitude": "118.3991111",
        "icon_latitude": "30.0672444",
        "scale": 100
    },
    {
        "id": 35,
        "type": 2,
        "name": "南方铁杉",
        "address": "海拔884米以上的黄山云谷寺位于云谷前",
        "desc": "名木，树高17米，胸围2.3米，冠幅18.9米*19.6米，树龄逾800年，原先树干上寄生一种“华东松寄生”，叶呈长条形，花、果均为红色，与铁杉树同株共生，因此一株树上长有两种枝干和两样叶子，即有针叶和阔叶。受科学水平所限，过去很长时间内缺乏植物分类知识，因此这一同株异属的古树也称为“异萝松”。",
        "icon": "marker/35/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            'marker/35/wechat_2025-07-17_114502_156.png',
            'marker/35/wechat_2025-07-17_145431_531.jpg'
        ],
        "longitude": "118.1852778",
        "latitude": "30.1197222",
        "icon_longitude": "118.1852778",
        "icon_latitude": "30.0027222",
        "scale": 100
    },
    {
        "id": 36,
        "type": 2,
        "name": "团结松",
        "address": "海拔1604米的黄山西海打鼓峰下，北海至西海路旁",
        "desc": "名木，树高14.5米，胸围2.2米，枝下高0.75米，冠幅12.5米*13.4米，树龄逾450年，1990年被联合国教科文组织列入世界文化与自然遗产名录。树根盘结，一松六茎，相抱相依，枝叶茂密，团团簇簇，竞相生长，象征中华民族的大团结，故名团结松。",
        "icon": "marker/36/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/36/36-团结松.jpg"
        ],
        "longitude": "118.1622222",
        "latitude": "30.1436111",
        "icon_longitude": "118.0622222",
        "icon_latitude": "30.2436111",
        "scale": 100
    },
    {
        "id": 37,
        "type": 2,
        "name": "孔雀松",
        "address": "海拔1718米的黄山贡阳山白鹅岭至白鹅山庄路旁",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录，树高6.9米，胸围1.1米，枝下高3.6米，冠幅8.5*9米，树龄逾200年，主枝向上，侧枝旁伸，头高尾长，似孔雀昂首挺立，振翅欲飞。",
        "icon": "marker/37/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/37/wechat_2025-07-16_171119_179.png",
            "marker/37/wechat_2025-07-16_171154_681.png"
        ],
        "longitude": "118.1763889",
        "latitude": "30.1363889",
        "icon_longitude": "117.8763889",
        "icon_latitude": "30.2363889",
        "scale": 100
    },
    {
        "id": 38,
        "type": 2,
        "name": "喜鹊登梅（仙人指路）松",
        "address": "黄山云谷寺步行至白鹅岭途中的皮篷路口处，海拔1392米的仙人指路怪石上",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录。树高2.8米，胸围0.92米，枝下高0.5米，冠幅4.5米*5米。松似古梅，枝干盘曲古朴，其旁有巧石状如喜鹊，松石组合成景，曰“喜鹊登梅”。",
        "icon": "marker/38/marker.png",
        "icon_scale": 85,
        "wh": 1.249,
        "thumbs": [
            "marker/38/喜鹊登梅.jpg"
        ],
        "longitude": "118.1697222",
        "latitude": "30.1394444",
        "icon_longitude": "118.0997222",
        "icon_latitude": "30.0894444",
        "scale": 100
    },
    {
        "id": 39,
        "type": 2,
        "name": "卧龙松",
        "address": "海拔1676米的黄山始信峰南侧悬崖石壁，探海松上方",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录。树高2.1米，胸围1.14米，冠幅6.5米*3.9米，明唐世靖《卧龙松》诗：“老干横披欹一壑，苍髯直上耸千峰。破天风云惊难起，始信山中有卧龙。”",
        "icon": "marker/39/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/39/39-卧龙松.jpg"
        ],
        "longitude": "118.17",
        "latitude": "30.1436111",
        "icon_longitude": "117.779",
        "icon_latitude": "30.1436111",
        "scale": 100
    },
    {
        "id": 40,
        "type": 2,
        "name": "棋枰松",
        "address": "海拔1758米的黄山光明顶至天海途中",
        "desc": "名木，1990年被联合国教科文组织列入世界文化与自然遗产名录。树冠平整如棋盘，故名。树高4.5米，胸围1.15米，枝下高1.8米，冠幅9.7米*8.3米，树龄逾200年，清代洪云行作《棋枰松》诗：“闻道骖鸾客，时来坐对松。樵柯从烂尽，此局几时终？”",
        "icon": "marker/40/marker.png",
        "icon_scale": 80,
        "wh": 1.249,
        "thumbs": [
            "marker/40/棋枰松.jpg"
        ],
        "longitude": "118.1636111",
        "latitude": "30.1341667",
        "icon_longitude": "118.0036111",
        "icon_latitude": "30.1341667",
        "scale": 100
    },
    {
        "id": 41,
        "type": 2,
        "name": "龙田乡桃林村苦槠树公园古树群",
        "address": "位于休宁县龙田乡桃林村",
        "desc": "位于休宁县龙田乡桃林村，距屯溪约50公里。古树群占地1公顷，总株数47株，主要树种有苦槠、南方红豆杉、枫香等，其中二级古树24株，三级古树23株，为典型徽派水口，内部环境优美，空气清晰，春季有桃花盛开加以点缀，风景优美，交通便利。同时有居民休息凉亭，周边有领鲜鱼庄，双双泉水鱼庄等可以提供住宿美食，美食以泉水鱼著称，还有各种当地美食产品，同时还可以体验当地采茶、挖笋子等活动。位于桃林村的“龙畔鱼庄”民宿距离古树微公园仅800米，住宿环境优美，设施齐全。古树微公园最佳拍摄点位于205国道的桃林桥附近。",
        "icon": "marker/41/marker.png",
        "icon_scale": 80,
        "wh": 1.79,
        "thumbs": [
            "marker/41/wechat_2025-07-16_170339_642.png"
        ],
        "longitude": "118.3094444",
        "latitude": "29.4261111",
        "icon_longitude": "118.3094444",
        "icon_latitude": "29.4261111",
        "scale": 100
    },
    {
        "id": 42,
        "type": 2,
        "name": "板桥乡樟前村徐源组水口古树群",
        "address": "位于休宁县板桥樟前村",
        "desc": "位于休宁县板桥樟前村，距县城约50公里。古树群占地0.3公顷，总株数28株，主要树种有枫香、红楠、钩栲、元宝槭等，其中二级古树一株、三级古树24株。为典型徽派水口林，内部环境整洁、设施完善、保护措施到位，开发程度尚可，最佳观赏季节为春秋季。樟前村是安徽省特色美食村，村内有辣椒粿、思乡粿等传统特色美食。村内有民宿两家，其中“伴山徽舍”入选安徽省银牌民宿，该民宿投入300万元，建筑面积670平方米，能容纳80人就餐，并设了8间客房。",
        "icon": "marker/42/marker.png",
        "icon_scale": 80,
        "wh": 1.761,
        "thumbs": [
            "marker/42/DJI_0205.jpg",
            "marker/42/徐源.jpg"
        ],
        "longitude": "117.8938084",
        "latitude": "29.5600084",
        "icon_longitude": "117.8938084",
        "icon_latitude": "29.5600084",
        "scale": 100
    },
    {
        "id": 43,
        "type": 2,
        "name": "黄村苦槠树",
        "address": "位于商山镇黄村村下黄村象鼻路王瑞生户门口",
        "desc": "黄山市的重点保护对象，位于商山镇黄村村下黄村象鼻路王瑞生户门口，至今已有160年的树龄。这棵古树地理位置也十分优越，距离国家级文物保护单位黄村进士第仅300米左右，当你漫步在古村落中，探寻 “进士第” 所蕴含的人文底蕴后，信步就能来到这棵苦槠树下，在古树与古村落交织的独特氛围中，感受自然与人文的完美融合。周边有黄村咖啡、进士故里民宿、黄村豆腐坊等文旅业态。",
        "icon": "marker/43/marker.png",
        "icon_scale": 80,
        "wh": 1.956,
        "thumbs": [
            "marker/43/wechat_2025-07-22_161027_422.png"
        ],
        "longitude": "118.17746991",
        "latitude": "29.67479507",
        "icon_longitude": "118.17746991",
        "icon_latitude": "29.67479507",
        "scale": 100
    },
    {
        "id": 44,
        "type": 2,
        "name": "休宁县齐云山榔梅树",
        "address": "位于休宁县齐云山洞天福地混元洞仙人床右下侧",
        "desc": "名木，瑯梅，蔷薇科杏属，又名古梅，植于休宁县齐云山景区洞天福地混元洞仙人床右下侧，树高12米，胸围1.5米，主枝分三股，树姿苍劲古朴，树龄500年，至今仍苍劲古朴，一枝干横空出世，别具情趣和顽强生机。与宋庆历五年（1045）琅琊山“欧梅”、宋宝元二年（1039）和县杜村“杜梅”、歙南洪家岭卖花渔村梅窗居士洪必信于唐乾符六年（879）所植梅树，同称安徽四大古梅。古榔梅被道教尊为神树，其果被尊为圣果。据明代《齐云山志》记载，嘉靖五年（1526年）齐云山道士方琼真访武当山，带回两株榔梅苗木，现仅存一株。最佳观赏季节为春季。周边有自由家营地、齐云小镇、横江等游览区，还有云归里、长生楼等皖美民宿。",
        "icon": "marker/44/marker.png",
        "icon_scale": 80,
        "wh": 1.956,
        "thumbs": [
            "marker/44/wechat_2025-07-16_170452_658.png"
        ],
        "longitude": "118.0380556",
        "latitude": "29.8111111",
        "icon_longitude": "118.0380556",
        "icon_latitude": "29.8111111",
        "scale": 100
    },
    {
        "id": 45,
        "type": 2,
        "name": "五城镇低台村苦槠树",
        "address": "五城镇低台村",
        "desc": "在五城镇低台村苦株树故事民宿深处，静默伫立着一棵阅尽千六百载沧桑的苦槠古树。其躯干虬枝盘曲，中阔竟可容十人环抱，如大地张开的怀抱，寓意深长：迎客松以秀姿相迎八方来客，苦槠树则以宏阔之量诚纳四海宾朋。当您信步于民宿小径，不经意间便会与这株千年“树灵”相遇。置身于古木苍劲的虬枝与雅致民宿交织的独特空间，浓荫如盖，树影斑驳，您将真切触摸到岁月馈赠的厚重，沉醉于自然伟力与人文匠心完美交融的隽永意境之中。",
        "icon": "marker/45/marker.png",
        "icon_scale": 80,
        "wh": 1.426,
        "thumbs": [
            "marker/45/1.png",
            "marker/45/2.png"
        ],
        "longitude": 118.089031,
        "latitude": 29.563507,
        "icon_longitude": 118.089031,
        "icon_latitude": 29.563507,
        "scale": 100
    },

    {
        "id": 46,
        "type": 4,
        "name": "箬岭古道",
        "address": "黄山区谭家桥、歙县许村",
        "desc": "箬岭古道，始建于隋朝（公元614年），全长约15公里，由青石板铺就，连接歙县许村镇与黄山区谭家桥镇，是古代徽州通往安庆、中原的重要战略通道。古道历经千年沧桑，至今仍保留着原始风貌，被誉为“徽州历史的活化石”，2018年入选“长三角十大古道”。  ",
        "icon": "marker/46/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/46/箬岭古道.png"
        ],
        "longitude": 118.316963,
        "latitude": 30.068989,
        "icon_longitude": 118.316963,
        "icon_latitude": 30.068989,
        "scale": 100
    },
    {
        "id": 47,
        "type": 4,
        "name": "桃岭古道",
        "address": "黄山区乌石乡",
        "desc": "桃岭古道，又称乾隆古道，修建于清代，是古代徽州到池州的交通干线，是青（阳）黟（县）古道的一部分。路面铺设青石板，当年“徽州担”的徽商就是沿着这条古通衢将山区的木竹、茶笋等土特产运往大商埠，将城镇的丝绸、布匹、盐、烟、日用百货挑往山区，古道联系着长江和新安江两大水系的贸易往来，流传着无数“长亭送别”的故事，当地民谣依稀可见古道的盛况：枞阳票子崭崭新，中朋不歇歇桃坑，桃坑有个好观音，腊梅一枝花，来珍盖过她。",
        "icon": "marker/47/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/47/1.png",
            "marker/47/2.png",
            "marker/47/3.png"
        ],
        "longitude": 117.954711,
        "latitude": 30.13653,
        "icon_longitude": 117.954711,
        "icon_latitude": 30.13653,
        "scale": 100
    },
    {
        "id": 48,
        "type": 4,
        "name": "徽开古道",
        "address": "休宁白际乡",
        "desc": "徽开古道，起点位于榆村乡岭脚村，途经白际至浙江省淳安县中洲镇的泰厦村，全程25公里，其精华为岭脚村至白际乡的15公里部分。这段古道攀山越崖，翻过海拔1208米的“白际岭”，穿行翠竹密林，蜿蜒在崇山峻岭中，在蔚蓝的天空下，如一挂天梯，连接着蓝天和白云，是一条集颜值与强度于一体徽州古道。",
        "icon": "marker/48/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/48/徽开古道.png"
        ],
        "longitude": 118.382886,
        "latitude": 29.599779,
        "icon_longitude": 118.369438,
        "icon_latitude": 29.573023,
        "scale": 100
    },
    {
        "id": 49,
        "type": 4,
        "name": "霞客古道",
        "address": "休宁县齐云山镇",
        "desc": "霞客古道，因明代旅行家徐霞客在万历四十四年（1616年）、四十六年（1618年）两次经此登临齐云山而得名。古道沿途“九里十三亭”不仅是休憩设施，更蕴含道教 “阴阳和合” 理念（“九” 为阳数之极，“十三” 象征龟纹至阴），与齐云山道教宫观、摩崖石刻共同构成完整的道教文化景观体系，反映了明代道教世俗化、大众化的传播轨迹。作为古代徽州地区通往齐云山的核心路径，它不仅是香客朝圣的 “天路”，也串联起周边村镇与齐云山的物资往来。",
        "icon": "marker/49/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/49/霞客古道.jpg"
        ],
        "longitude": 118.045709,
        "latitude": 29.818432,
        "icon_longitude": 118.045709,
        "icon_latitude": 29.818432,
        "scale": 100
    },
    {
        "id": 50,
        "type": 4,
        "name": "徽饶古道",
        "address": "休宁县板桥乡",
        "desc": "徽饶古道，始建于唐代,是徽州通往饶州的古驿道。徽饶古驿道浙岭段北起休宁县板桥乡樟前村，南至婺源县浙源乡虹关村，有千余年历史。位于休宁板桥的浙岭顶是春秋时期吴国与楚国的分界地，有“吴楚分源”的地标。古驿道全程用五六尺长，一尺来宽的青石条铺砌而成的，沿线生态一流，林茶古木密布，是徒步爱好者的理想线路。",
        "icon": "marker/50/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/50/1.png",
            "marker/50/2.png"
        ],
        "longitude": 117.908029,
        "latitude": 29.569975,
        "icon_longitude": 117.908029,
        "icon_latitude": 29.569975,
        "scale": 100
    },
    {
        "id": 51,
        "type": 4,
        "name": "徽池古道",
        "address": "黟县柯村村",
        "desc": "徽池古道为古代徽州府城至安庆府城的陆路通道，全程约200公里，是徽州“九龙出海”古官道体系的重要构成部分。这些现存石板道与附属遗存，是研究徽州交通史与茶文化的重要实证。徽池古道中的榉根岭段极具战略意义，现存的关隘为曾国藩为抵御太平军所建，城门和石长城均由青石板砌成，长城遗址总长约为14公里。历史上，为抢占这一军事要塞，曾爆发过大小战役 10多起，其中清军与太平军在此地的争夺战尤为著名。",
        "icon": "marker/51/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/51/1.jpg",
            "marker/51/2.jpg"
        ],
        "longitude": 117.750107,
        "latitude": 30.110897,
        "icon_longitude": 117.750107,
        "icon_latitude": 30.110897,
        "scale": 100
    },
    {
        "id": 52,
        "type": 4,
        "name": "祁黟古道",
        "address": "黟县碧阳镇",
        "desc": "祁黟古道，是连接古徽州祁门县与黟县的重要陆路通道，对两地物资流通、文化融合有着深远影响。在历史上，祁黟古道不仅是徽商运输茶叶、布匹、瓷器等物资的重要路径，还承载着两地的文化交流。明清时期，黟县的徽商常经此道前往祁门，再转至江西等地经商，而祁门的文人雅士也多通过这条古道赴黟县访友论学，促进了两地文风的兴盛。",
        "icon": "marker/52/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/52/1.png",
            "marker/52/2.png"
        ],
        "longitude": 117.849781,
        "latitude": 29.895205,
        "icon_longitude": 117.849781,
        "icon_latitude": 29.895205,
        "scale": 100
    },
    {
        "id": 53,
        "type": 4,
        "name": "大洪岭古道",
        "address": "祁门县大坦乡",
        "desc": "作为著名的徽商要道，大洪岭古道是古徽州通往当时省会安庆的必经之路，也是阊江与秋浦河的分水岭。古道全部用青石板铺设，沿线分布着古桥、古亭、碑亭等古建筑。此外，大洪岭还是昔日兵家必争之要道，岭上至今留存几条长达数十米的战壕。大洪岭古道集历史、文化、商贸、军事、生态价值于一体，为研究徽商文化、徽州民俗、徽州古建提供了珍贵的实物资料。",
        "icon": "marker/53/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/53/1.png",
            "marker/53/2.png"
        ],
        "longitude": 117.699253,
        "latitude": 30.002124,
        "icon_longitude": 117.631355,
        "icon_latitude": 30.002124,
        "scale": 100
    },
    {
        "id": 54,
        "type": 4,
        "name": "汤岭古道",
        "address": "黄山风景区",
        "desc": "黄山磴道，初始于唐宋，形成于明清，发展于民国，完善于当代，形成了以光明顶为中心东西南北四向通达的道网。现存较好的古道有十条（段）约40千米3.6万级。汤岭古道，起点温泉至终点钓桥长约6000米，是黄山景区早期开辟的登山道，依山就势铺筑，沿途巧设亭、桥、关、庵等功能性建筑，反映出时代人文和历史变迁，成为见证黄山建设发展的珍贵实物，具有较高了历史、科学和艺术价值，为全国重点文物保护单位黄山登山古道及古建筑的组成部分。",
        "icon": "marker/54/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/54/汤岭古道.png"
        ],
        "longitude": 118.184433,
        "latitude": 30.095862,
        "icon_longitude": 118.184433,
        "icon_latitude": 30.095862,
        "scale": 100
    },
    {
        "id": 55,
        "type": 4,
        "name": "文昌古道",
        "address": "歙县昌溪乡",
        "desc": "文昌古道，最早修建始于民国五年（1916年），堪称徽州古道建筑的典范。整条古道全部由精细加工的青石板铺就，古道的坡度设计极具科学性，特别是\"百步云梯\"段，百余个石阶依悬崖砌就，呈优美的弧形绕过山坳，形似\"弹奏中的琴键\"，既保证了安全性，又创造了视觉美感。文昌古道不仅是一条交通要道，更是徽州文化的重要载体，承载着丰富的人文历史和红色记忆。",
        "icon": "marker/55/marker.png",
        "icon_scale": 105,
        "wh": 1.426,
        "thumbs": [
            "marker/55/1.jpg",
            "marker/55/2.jpg",
            "marker/55/3.jpg"
        ],
        "longitude": 118.701248,
        "latitude": 29.886745,
        "icon_longitude": 118.701248,
        "icon_latitude": 29.886745,
        "scale": 100
    },
    {
        "id": 56,
        "type": 4,
        "name": "西宏古道",
        "address": "黟县",
        "desc": "西宏古道位于安徽黟县，南起西递，沿虞溪河，穿过 “鸳鸯谷”，经奇墅湖至宏村，全程 8.2 公里。它古为徽州西南部商旅学子北上要道及西递、宏村百姓生活便道。古道较为平缓，沿途风景如画，有峡谷、碧潭、古村落等景观，现为黟县国家级登山健身步道中美丽的一段。",
        "icon": "marker/56/marker.png",
        "icon_scale": 105,
        "wh": 1.422,
        "thumbs": [
            "marker/56/1.jpg"
        ],
        "longitude": 117.99599,
        "latitude": 29.90334,
        "icon_longitude": 117.99599,
        "icon_latitude": 29.90334,
        "scale": 100
    },
    {
        "id": 57,
        "type": 4,
        "name": "通灵古道",
        "address": "徽州区",
        "desc": "通灵古道位于徽州区潜口镇、呈坎镇东南，为蜀源村从北、呈坎村从东两个方向通往灵山村的旧时道路。有千余年通行历史，全长7220米。古道以山道、坡路为主，多为花岗岩石板、泥砂路面。历史上为三村东往徽州府，北上宣州、芜湖的官道。旧时每年六月二十四日，灵山传统雷祖庙会兴盛，四乡八邻争相赶赴，一时“拜神者塞途”，“焚香者络绎于道”成为古道的盛景。",
        "icon": "marker/57/marker.png",
        "icon_scale": 105,
        "wh": 1.422,
        "thumbs": [
            "marker/57/1.jpg"
        ],
        "longitude": 118.320241,
        "latitude": 29.919308,
        "icon_longitude": 118.282894,
        "icon_latitude": 29.931967,
        "scale": 100
    }
]